import { render, staticRenderFns } from "./blocks.vue?vue&type=template&id=18f70dbc&scoped=true&"
var script = {}
import style0 from "./blocks.vue?vue&type=style&index=0&id=18f70dbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f70dbc",
  null
  
)

export default component.exports